/**
 * Moduł obsługujący weryfikację usług dodanych do koszyka, które wykluczają się wzajemnie.
 * Metody obsługiwane przez moduł:
 * - getAddedServicesWithExclusion() - pobiera listę wszystkich usług dodanych do koszyka, które posiadają informację o grupie wykluczającej się wzajemnie (czyli tylko jedna usługa możliwa w ramach danej grupy wykluczającej)
 * - getExcludedServicesForRemove(added, removed) - pobiera listę usług, które należy usunąć z koszyka w związku z wykluczeniami, na podstawie przekazanej listy usług aktualnie dodawanych oraz listy usług aktualnie usuwanych. Metoda weryfikuje czy nie ma duplikatów w liście usuwanych.
 */
app.service('basketServicesWithExclusion', function (console, pageConfig) {

	function getAddedServicesWithExclusion() {
		const config = pageConfig.getData('basket');
		const products = config.items;
		let addedServicesWithExclusion = [];
		if (!products || !products.length) {
			return [];
		}
		products.forEach(product => {
			if (product.services?.length) {
				product.services.forEach(service => {
					if (service.excluded) {
						addedServicesWithExclusion.push({
							id: service.id,
							plu: service.code,
							quantity: service.quantity / 1,
							productPlu: product.plu,
							mainItemId: product.cartId,
							excludedServicesGroupId: service.excluded,
						});
					}
				});
			}
		});
		return addedServicesWithExclusion.length ? addedServicesWithExclusion : [];
	}
	function getExcludedServicesForRemove(added, removed) {
		const addedServicesWithExclusion = getAddedServicesWithExclusion();
		let addedServicesWithExclusionToRemove = [];
		if (addedServicesWithExclusion?.length && added?.length) {
			added.forEach(addedService => {
				const foundService = addedServicesWithExclusion.find(service => service.excludedServicesGroupId == addedService.excludedServicesGroupId && service.mainItemId == addedService.mainItemId && service.id != addedService.id);
				if (foundService) {
					if (!removed?.some(removedService => removedService.id == foundService.id && removedService.mainItemId == foundService.mainItemId)) { // odfiltrowanie duplikatów, które już są w liście removed
						addedServicesWithExclusionToRemove.push(foundService);
					}
				}
			});
		}
		return addedServicesWithExclusionToRemove;
	}

	return {
		getAddedServicesWithExclusion,
		getExcludedServicesForRemove
	};
});
